import React from "react";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { updateRange, clearFilter } from "../../services/filters/actions";
import "./style.scss";
import swal from "sweetalert";

const Filters = ({ fetch }) => {
  const dispatch = useDispatch();
  const { range, app } = useSelector(({ filtersState }) => ({
    range: filtersState.range,
    app: filtersState.app,
  }));

  const handleChange = (e) => {
    let latestDate = new Date(e.target.value);
    let todayDate = new Date();
    if (latestDate.getTime() > todayDate.getTime())
      return swal("Wrong Date", "You have selected a future date", "warning");
    dispatch(
      updateRange({
        ...range,
        [e.target.name]: moment(e.target.value).format("YYYY-MM-DD"),
      })
    );
  };
  const clearFilters = () => {
    dispatch(clearFilter());
  };

  const applyEvent = () => {
    if (fetch) fetch();
  };

  return (
    <div className="filter_container">
      <div className="filters">
        <input
          type="date"
          name="from"
          placeholder="date range"
          value={range.from}
          onChange={handleChange}
          style={{ marginRight: "0.2rem" }}
        />
        <span style={{ color: "#555" }}>To</span>
        <input
          type="date"
          name="to"
          placeholder="date range"
          value={range.to}
          onChange={handleChange}
          style={{ marginLeft: "0.2rem" }}
        />
        <select name="status" id="status">
          <option value={app.environment}>{app.environment}</option>
        </select>
      </div>
      <div>
        <button
          className="clear"
          onClick={() => applyEvent()}
          style={{ margin: "0 0.5rem" }}
        >
          Apply
        </button>
        <button className="clear" onClick={clearFilters}>
          Clear Filters
        </button>
      </div>
    </div>
  );
};

export default Filters;
